











































































import { Vue, Component, Prop } from "vue-property-decorator";
import {ActivitySessionWaitingContactPermissionName} from "@activities/interfaces/activity-session-waiting-contact";
import type {
   ActivitySessionWaitingContactsDefaultFilterTableInterface,
  ActivitySessionWaitingContactsDefaultTableItemInterface,
} from "@activities/interfaces/activity-session-waiting-contact";



import TableWrapper from "@shared/layouts/wrappers/table/table-wrapper.vue";
import PaginationInterface from "@core/interfaces/pagination-interface";
import OrderingInterface from "@core/interfaces/ordering-interface";
import { SelectOptionInterface } from "@shared/interfaces/inputs";
import ActivitySessionWaitingContactsFilters from "@activities/components/tables/activity-session-waiting-contacts-table/activity-session-waiting-contacts-filters.vue";
import TableOrdering from "@shared/components/tables/table-ordering/table-ordering.vue";
import { BPCTableField } from "@shared/interfaces/bpc-table-interface";
import {
  ActivitySessionWaitingContactDisplayFields,
  defaultTableFields,
} from "@activities/config/activity-session-waiting-contact-config";
import Table from "@shared/components/tables/table.vue";
import BpcPageTitle from "@shared/layouts/components/page-title/page-title.vue";
import DisplayContactLink from "@shared/components/displays/display-contact-link/display-contact-link.vue";
import DisplayFieldDateTime from "@shared/components/displays/display-field-date-time/display-field-date-time.vue";
import DisplayFieldDate from "@shared/components/displays/display-field-date/display-field-date.vue";

@Component({
  name: "bc-activity-session-waiting-contacts-table",
  components: {
    "bpc-table-wrapper": TableWrapper,
    "bc-activity-session-waiting-contacts-filters": ActivitySessionWaitingContactsFilters,
    "bc-table-ordering": TableOrdering,
    "bpc-table": Table,
    "bpc-page-title": BpcPageTitle,
    "bpc-display-contact-link": DisplayContactLink,
    "bpc-display-date-time": DisplayFieldDateTime,
    "bpc-display-date": DisplayFieldDate,
  },
})
export default class ActivitySessionWaitingContactsTable extends Vue {
  // PROPS
  @Prop({ type: String }) readonly actionsPortalTarget: string;
  @Prop({ type: Boolean, default: false }) readonly disabled: boolean;
  @Prop({ type: Boolean, default: true }) readonly showFilters: boolean;
  @Prop({ type: Boolean, default: true }) readonly showOrdering: boolean;
  @Prop({ default: () => defaultTableFields })
  readonly tableFields!: BPCTableField[];
  @Prop({ type: Boolean, default: true }) readonly withUrlParams: boolean;
  @Prop({ type: Boolean, default: true }) readonly noCheckboxColumn: boolean;
  @Prop({ type: Object })
  readonly initialFilters: ActivitySessionWaitingContactsDefaultFilterTableInterface;

  // DATA
  // pagination
  pagination: PaginationInterface = {
    current_page: 1,
    last_page: 1,
    per_page: 15,
    from: 0,
    to: 0,
    total: 0,
  };
  pageOptions: number[] = [5, 10, 15, 20, 50, 100, 200];

  // filters
  filters: ActivitySessionWaitingContactsDefaultFilterTableInterface = {
    search: null,
  };

  // Ordering
  ordering: OrderingInterface = {
    order_by: "created_at",
    order_direction: "asc",
  };
  // Ordering options
  orderByOptions: SelectOptionInterface[] = [
    {
      text: this.$t("global.ordering.created_at.label").toString(),
      value: "created_at",
    },
  ];

  tableItems: ActivitySessionWaitingContactsDefaultTableItemInterface[] = [];
  checkedAllEntities: boolean = false;
  loading: boolean = false;

  // LIFECYCLE

  mounted() {
    this.initializeFiltersFromProperties();
    this.getWaitingListIfStopChanging();
  }

  // COMPUTED

  get tenantId() {
    return this.$store.getters["tenant/selectedTenantId"];
  }

  get permissionEntityName(): string {
    return ActivitySessionWaitingContactPermissionName;
  }

  get showCreatePageAction(): boolean {
    return (
      !this.disabled &&
      this.$authorizationService.hasPermissionForAction(
        this.permissionEntityName,
        "store"
      )
    );
  }

  get fieldsToShow(): object[] {
    return this.tableFields.sort((f1, f2) => f1.order - f2.order);
  }

  // Table column config
  get displayConfig() {
    return ActivitySessionWaitingContactDisplayFields;
  }

  // Change detector
  get changeDetectorStr(): string {
    return [
      this.pagination.per_page,
      this.pagination.current_page,
      this.ordering.order_by,
      this.ordering.order_direction,
      this.filters.search,
    ].join("--");
  }

  // Method called from the refresh button at filter level.
  clickOnReload() {
    this.getWaitingListIfStopChanging();
  }
  // Method called from the order direction button
  clickOnChangeOrderDirection(direction: string) {
    this.ordering.order_direction = direction;
  }
  // Method called when selecting all rows of the table
  onCheckAll(val: boolean) {
    this.checkedAllEntities = val;
  }

  // Params sents in the fetch request
  getQueryParams() {
    return {
      order_by: this.ordering.order_by,
      order_direction: this.ordering.order_direction,
      per_page: this.pagination.per_page,
      page: this.pagination.current_page,
      search: this.filters.search,
      //resource_ids: this.filters.resource_ids,
      //status: this.filters.status,
    };
  }

  setUrlParams(params) {
    if (this.withUrlParams) {
      this.$router.push({ query: params }).catch((e) => {
        return null;
      });
    }
  }

  //get access points with a delay after changes detected
  getWaitingListIfStopChanging() {
    const changeStr = this.changeDetectorStr;
    setTimeout(() => {
      if (changeStr === this.changeDetectorStr) {
        this.getActivitySessionWaitingContactss();
      }
    }, 300);
  }

  async getActivitySessionWaitingContactss() {
    this.loading = true;
    this.checkedAllEntities = false;
    const params = this.getQueryParams();
    const url = this.$bpcApiRouteHelper.getEntityPath(
      "activity-session-waiting-contacts"
    );
    const res = await this.$bpcApi.get(url, { params: params }).toPromise();
    console.log(res);
    this.tableItems = res.data;
    this.pagination = res.meta;
    this.setUrlParams(params);
    this.loading = false;
  }

  // Display modal
  initializeFiltersFromProperties() {
    if (this.initialFilters) {
      this.filters.search = this.initialFilters?.search || null;
    }
  }
}
